// Requiry Flickity
var Flickity = require('flickity');